export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_sampleStyleNo') || '产品款号',
    field: 'sampleStyleNo',
    headerAlign: 'left',
    align: 'left',
    minWidth: 150,
  },
  {
    title: that.$l('table_label_sampleBarcode') || '条码号',
    field: 'sampleBarcode',
    headerAlign: 'left',
    align: 'left',
    minWidth: 150,
  },
  {
    title: that.$l('table_label_printTimes') || '打印次数',
    field: 'printTimes',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
  },

  {
    title: that.$l('table_label_prebuiltStatus') || '状态',
    field: 'prebuiltStatus',
    minWidth: 120,
    align: 'center',
    headerAlign: 'center',
    slots: { default: 'prebuiltStatus' },
    showHeaderOverflow: true,
  },

  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createBy' },
  },

  {
    title: that.$l('table_label_printDate') || '打印时间',
    field: 'printDate',
    minWidth: 170,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'printDate' },
  },

  {
    title: that.$l('table_label_useBy') || '使用人',
    field: 'useBy',
    minWidth: 170,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'useBy' },
  },

]
